import commonActionHandle from "@/commonActionHandle";
// Api  
import api from '@/api/baseApi';
// Extend
import base from '@/scripts/base';

// Constant
import { SETTINGS_USER_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";


export default {
    extends: base,  
    data() {
        isEnabled:  false
    }
}